import { PrimaryButton } from "components/Button/style";
import {
  ButtonContainer,
  Container,
  ContainerHeader,
  FormContainer,
  MaisFiltrosContainer,
  Title,
} from "./style";
import { FaFile, FaFilter } from "react-icons/fa";
import { Controller, useForm } from "react-hook-form";
import { Col, Form, Row } from "react-bootstrap";
import { useMaskInput } from "hooks/useMaskInput";
import { yupResolver } from "@hookform/resolvers/yup";
import { IFiltrosListarSolicitacoesLicenciamento } from "../../Interfaces/IFiltrosListarSolicitacoesLicenciamento";
import { filtrosListarSolicitacoesLicenciamento } from "../../Validate/validator";
import { CustomInput } from "components/CustomInput";
import { CustomDatePicker } from "components/DatePicker";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { Cobrar, STATUS_OPTIONS, UF_OPTIONS } from "../../Constants";
import { MaisFiltros } from "components/ButtonModal";
import { useMaisFiltros } from "hooks/useMailFiltros";
import { InternoLw } from "components/InternoLw";
import { useState } from "react";

interface Props {
  handleSubmitFiltros: (dados: IFiltrosListarSolicitacoesLicenciamento) => void;
  empresasOptions: IOptions[];
  onClickEmitir: () => void;
}

export function FiltrosLicenciamento({
  handleSubmitFiltros,
  empresasOptions,
  onClickEmitir,
}: Readonly<Props>) {
  const {
    handleAplicarMaisFiltros,
    handleFormSubmit,
    handleNaoUsarMaisFiltros,
  } = useMaisFiltros();

  const [inicioDataSolicitacao, setInicioDataSolicitacao] = useState<Date>();
  const [fimDataSolicitacao, setFimDataSolicitacao] = useState<Date>();
  const onChangeDataSolicitacao = (dates: any) => {
    const [start, end] = dates;
    setInicioDataSolicitacao(start);
    setFimDataSolicitacao(end);
  };

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors, isValid, isSubmitted },
  } = useForm({
    resolver: yupResolver(filtrosListarSolicitacoesLicenciamento),
  });
  const { mInputPlaca } = useMaskInput();

  return (
    <Container>
      <ContainerHeader>
        <Title>Filtros</Title>

        <PrimaryButton
          buttonWidth="xl"
          buttonWidthTipo="px"
          onClick={onClickEmitir}
        >
          Emitir licenciamento <FaFile />
        </PrimaryButton>
      </ContainerHeader>
      <hr />
      <FormContainer>
        <Form
          noValidate
          onSubmit={handleSubmit((dados) => {
            handleFormSubmit({
              dados: {
                ...dados,
                placa: dados.placa?.replace(/-/g, ""),
              },
              excluir: ["renavam", "idEmpresa", "cobranca"],
              resetCallback: reset,
              submitCallback: handleSubmitFiltros,
            });
          })}
        >
          <Row>
            <Col lg="2">
              <Form.Group>
                <Form.Label>Placa</Form.Label>
                <Controller
                  control={control}
                  name="placa"
                  render={({ field: { onChange, value } }) => (
                    <CustomInput
                      style={{ height: "2.2rem", borderRadius: "0.5rem" }}
                      type="text"
                      placeholder="Digite a placa"
                      value={value!}
                      onChange={(e: any) => onChange(mInputPlaca(e))}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <Form.Group>
                <Form.Label>Data da solicitação</Form.Label>
                <Controller
                  control={control}
                  name="periodoSolicitacao"
                  render={({ field: { onChange } }) => (
                    <CustomDatePicker
                      selected={inicioDataSolicitacao}
                      onChange={(update) => {
                        onChange(update);
                        onChangeDataSolicitacao(update);
                      }}
                      startDate={inicioDataSolicitacao}
                      endDate={fimDataSolicitacao}
                      rangeSelect={true}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <Form.Group>
                <Form.Label>Status emissão</Form.Label>
                <Controller
                  control={control}
                  name="statusEmissao"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={STATUS_OPTIONS}
                      selectedValue={value}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <Form.Group>
                <Form.Label>UF</Form.Label>
                <Controller
                  control={control}
                  name="uf"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={UF_OPTIONS}
                      selectedValue={value}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col lg="2">
              <ButtonContainer>
                <PrimaryButton type="submit" disabled={false}>
                  <FaFilter /> Filtrar
                </PrimaryButton>
                <PrimaryButton
                  onClick={() => {
                    setFimDataSolicitacao(undefined);
                    setFimDataSolicitacao(undefined);
                    setValue("periodoSolicitacao", [null, null]);
                    onChangeDataSolicitacao([null, null]);
                    reset({
                      placa: "",
                      periodoSolicitacao: null,
                      renavam: null,
                      statusEmissao: null,
                      idEmpresa: null,
                      uf: null,
                      cobranca: null,
                    });
                    handleSubmitFiltros({});
                  }}
                  disabled={false}
                  outline={true}
                  variante="primary"
                  type="button"
                >
                  Limpar
                </PrimaryButton>
              </ButtonContainer>
            </Col>
            <Col lg="2" style={{ paddingTop: "0.5rem" }}>
              <MaisFiltrosContainer>
                <MaisFiltros
                  cancelarOnClick={() => {
                    handleNaoUsarMaisFiltros({
                      excluir: ["renavam", "idEmpresa", "cobranca"],
                      resetCallback: reset,
                    });
                  }}
                  handleClickAplicarFiltros={handleAplicarMaisFiltros}
                  limparTudoOnClick={() => {
                    handleNaoUsarMaisFiltros({
                      excluir: ["renavam", "idEmpresa", "cobranca"],
                      resetCallback: reset,
                    });
                  }}
                  widthModal="lg"
                >
                  <Form.Group>
                    <Form.Label>Renavam</Form.Label>
                    <Controller
                      control={control}
                      name="renavam"
                      render={({ field: { onChange, value } }) => (
                        <CustomInput
                          type="text"
                          placeholder="Digite o renavam"
                          value={value ?? ""}
                          onChange={(e: any) => {
                            onChange(e);
                          }}
                          mensagemErro={errors.renavam?.message}
                          isValid={
                            isSubmitted &&
                            isValid &&
                            (value ? value.length >= 1 : false)
                          }
                          isInvalid={!!errors.renavam}
                        />
                      )}
                    />
                  </Form.Group>
                  <Form.Group style={{ marginTop: 16 }}>
                    <Form.Label>Empresa</Form.Label>
                    <Controller
                      control={control}
                      name="idEmpresa"
                      render={({ field: { onChange, value } }) => (
                        <DropdownSelect
                          options={empresasOptions}
                          selectedValue={value}
                          onSelect={onChange}
                          searchable
                        />
                      )}
                    />
                  </Form.Group>
                  <InternoLw>
                    <Form.Group style={{ marginTop: 16 }}>
                      <Form.Label>Cobrança</Form.Label>
                      <Controller
                        control={control}
                        name="cobranca"
                        render={({ field: { onChange, value } }) => (
                          <DropdownSelect
                            options={[
                              {
                                value: Cobrar.SIM,
                                label: "Cobrado do cliente",
                              },
                              {
                                value: Cobrar.NAO,
                                label: "Isento de cobrança",
                              },
                            ]}
                            selectedValue={value}
                            onSelect={onChange}
                          />
                        )}
                      />
                    </Form.Group>
                  </InternoLw>
                </MaisFiltros>
              </MaisFiltrosContainer>
            </Col>
          </Row>
        </Form>
      </FormContainer>
    </Container>
  );
}
